import React from 'react';
import Header from './Header';
import TermsOfUseEnglish from './TermsOfUseEnglish';
import TermsOfUseSinhala from './TermsOfUseSinhala';
import { useLanguage } from './LanguageContext';
import Footer from './Footer';

const TermsOfUse = () => {

  const { language } = useLanguage();
  
  return (
    <>
      <Header />
      {language === "sinhala" ? <TermsOfUseSinhala /> : <TermsOfUseEnglish />}
      <Footer />
    </>
  );

}

export default TermsOfUse;

